<template>
    <div id="Reporting" v-if="policies" class="reportingDiv" style="min-height: inherit; display: flex; flex-direction: column;">
        <Header title="Payroll Self-Reporting"/>
        <div class="mainbody">
            <div id="content">
                <h2>Payroll Period: <span v-if="current">{{ reportingDateToUsDateRange(reporting, 'to') }}</span></h2>
                <div v-if="current" class="bracket-green">
                    <p>You are self-reporting payroll for the month of {{reportingMonth()}}. Ensure that the payroll
                    amounts entered below include all paychecks created during the period between
                    {{ reportingDateToUsDateRange(reporting, 'and') }}. If you do not report your payroll before the 10th,
                    the estimated premium will be withdrawn on the 15th.</p>
                </div>

                <ReportingTable v-bind:gatherPayroll="true"/>
            </div>
            <CompanyInfo/>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from './shared/Header';
import CompanyInfo from './shared/CompanyInfo';
import ReportingTable from "./ReportingTable";
import { create, reportingPeriod } from '@/utils/helpers';

import mixin from './mixins/confAndReportingMixin';

export default {
    mixins:[mixin],
    name: 'Reporting',
    components: { CompanyInfo, Header, ReportingTable },
    data() {
        return {
            current: {}
        }
    },
    computed: {
        ...mapState([ 'policies', 'reporting', 'contact' ])
    },
    methods: {
        reportingMonth() {
            return reportingPeriod(this.reporting.date)
        }
    },
    created() {
        create(this)
    }
}
</script>
